import { render } from "./QuantityInput.vue?vue&type=template&id=da286bb8&bindings={}"
import script from "./QuantityInput.vue?vue&type=script&lang=ts"
export * from "./QuantityInput.vue?vue&type=script&lang=ts"
script.render = render

export default script